import { zodCreatedListResponseSchema } from '../../validations';

export const zodCreateSiteViaCSVResponseSchema = zodCreatedListResponseSchema;
